import { Component, h } from '@stencil/core';
import { getCanPostQuestion } from '@ugc-api/question';
import state from '@ugc-store';
import { handleErrorMessage, login } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-qna-ask-question',
  shadow: false,
})
export class UgcQnaAskQuestion {
  isRequest = false;

  async onClickAskQuestion() {
    if (this.isRequest) return;
    const { isLogin } = state;

    // user not login
    if (!isLogin) {
      login();
      return;
    }

    try {
      this.isRequest = true;
      const { firstTime = false } = ((await getCanPostQuestion()) as any) || {};
      this.isRequest = false;

      state.isFirstAskQuestion = firstTime;
      state.isShowAskModal = true;
    } catch (e) {
      this.isRequest = false;
      handleErrorMessage(e);
    }
  }

  render() {
    const {
      qnaStaticLanguage: { IDS_UGC_BTN_ASK_QUESTION },
      actionPermission: { question: questionButtonDisabled },
      isDesktop,
    } = state;
    return (
      <ugc-button
        type={isDesktop ? 'ghost' : 'primary'}
        height="48"
        fontSize="16"
        style={!isDesktop && { display: 'block', marginBottom: '16px' }}
        disabled={questionButtonDisabled}
        onClick={this.onClickAskQuestion}
      >
        {IDS_UGC_BTN_ASK_QUESTION}
      </ugc-button>
    );
  }
}
